import React from "react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { GetURL } from '../utils';
import ScrollAnimation from "react-animate-on-scroll";
import "./BlogSideBar.scss";

const BlogSideBar = (props) => {
    const sidebarData = Array.isArray(props?.data) ? props.data[0] : props?.data;
    if (!sidebarData) return null;

    return (
        <ScrollAnimation animateIn="fadeInUp">
            <div className="rtl-block">
                <span className="text">{sidebarData?.List_Title}</span>
                <div className="about-wrap">
                    {sidebarData?.List_Component?.map((item, k) => (
                        <Link to={GetURL(item?.List_Link?._id)} className="story-wrapper d-flex about-story" key={k}>
                            <div className="img-wrap">
                                <GatsbyImage
                                        loading='lazy'
                                        image={getImage(item?.Tile_Image?.url_sharp_sm)}
                                        alt={item?.Tile_Image?.alternativeText ? item?.Tile_Image?.alternativeText : props?.data?.List_Title + "- tlc Estate Agents"} 
                                    />
                            </div>
                            <div className="our-img d-flex align-items-center justify-content-between">
                                <span className="story">{item.Title}</span>
                                <i className="circle-arrow"></i>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </ScrollAnimation>
    );
};

export default BlogSideBar;